import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { FormTaskAssignment } from '../domain/form-task-assignment';
import { Observable } from 'rxjs';
import { PhobosTaskTemplate } from '../domain/phobos-task-template';
import { CreateTaskRequest } from './request/create-task-request';
import { UpdateTaskRequest } from './request/update-task-request';
import { HttpClient } from '@angular/common/http';
import { HttpServiceParent } from './httpServiceParent';
import { PropertyStoreService } from './stores/property-store.service';
import { AiToggleResponse } from './response/phobos-task-update-response';
import { TaskStage } from '../domain/task-stage';

@Injectable({
   providedIn: 'root'
})
export class PhobosTaskService extends HttpServiceParent {
   constructor(
      private http: HttpClient,
      private propertyStore: PropertyStoreService
   ) {
      super(propertyStore);
   }

   getTasksByPropertyId(propertyId: number): Observable<PhobosTaskTemplate[]> {
      return this.http.get<PhobosTaskTemplate[]>(
         `${environment.apiEndpoint}/phobos/task/property/${encodeURIComponent(
            propertyId
         )}`,
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   getTasksByOrgId(orgId: number): Observable<PhobosTaskTemplate[]> {
      return this.http.get<PhobosTaskTemplate[]>(
         `${environment.apiEndpoint}/phobos/task/organisation/${encodeURIComponent(
            orgId
         )}`,
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   getTasksByTaskId(taskId: number): Observable<FormTaskAssignment[]> {
      return this.http.get<FormTaskAssignment[]>(
         `${environment.apiEndpoint}/phobos/task/${encodeURIComponent(taskId)}`,
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   getTaskStages(taskId: number, propertyId: number): Observable<TaskStage[]> {
      return this.http.get<TaskStage[]>(
         `${environment.apiEndpoint}/phobos/task/${encodeURIComponent(taskId)}/property/${encodeURIComponent(propertyId)}/stage`,
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   createTask(task: CreateTaskRequest): Observable<PhobosTaskTemplate> {
      return this.http.post<PhobosTaskTemplate>(
         `${environment.apiEndpoint}/phobos/task`,
         task,
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }

   setAiActive(
      taskId: number,
      propertyId: number,
      isActive: boolean
   ): Observable<AiToggleResponse> {
      return this.http.put<AiToggleResponse>(
         `${environment.apiEndpoint}/phobos/task/${encodeURIComponent(taskId)}/property/${encodeURIComponent(propertyId)}/ai`,
         { isActive },
         { headers: this.headers, responseType: 'json' }
      );
   }

   removeTaskFromProperty(taskId: number, propertyId: number): Observable<void> {
      return this.http.put<void>(
         `${environment.apiEndpoint}/phobos/task/${encodeURIComponent(taskId)}/property/${encodeURIComponent(propertyId)}`,
         {
            IsEnabled: false
         },
         { headers: this.headers, responseType: 'json' }
      );
   }

   editTask(
      task: UpdateTaskRequest,
      taskTemplateId: number
   ): Observable<PhobosTaskTemplate> {
      return this.http.put<PhobosTaskTemplate>(
         `${environment.apiEndpoint}/phobos/task/${encodeURIComponent(taskTemplateId)}`,
         task,
         {
            headers: this.headers,
            responseType: 'json'
         }
      );
   }
}
